import type { TrackingConsentMode } from './tracking-consent-mode.model';

export function generateTrackingConsentMode({
  id = '192.168.1.1',
  isEnabled = false,
}): TrackingConsentMode {
  return {
    id,
    isEnabled,
  };
}
